export enum FilterOperator {
  OR = "OR",
  AND = "AND",
}
